"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var SavingSpinner =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SavingSpinner, _PureComponent);

  function SavingSpinner() {
    (0, _classCallCheck2.default)(this, SavingSpinner);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SavingSpinner).apply(this, arguments));
  }

  (0, _createClass2.default)(SavingSpinner, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIFlex.default, {
        align: "center",
        justify: "end"
      }, _react.default.createElement(_UILoadingSpinner.default, {
        "data-test-id": "autosave-spinner",
        size: "extra-small",
        className: "m-right-2"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: 'saving'
      }));
    }
  }]);
  return SavingSpinner;
}(_react.PureComponent);

exports.default = SavingSpinner;
module.exports = exports.default;